import React, { memo } from "react"
import { graphql, useStaticQuery } from "gatsby"
import { Text, VStack } from "@chakra-ui/react"

import { FormButton } from "@app/components/Form/FormButton"

type Props = {
  handleToggle: () => void
}

export const ProductGiftcardBalanceToggle: React.FC<Props> = memo(({ handleToggle }) => {
  const { giftcard } = useStaticQuery<GatsbyTypes.ProductGiftcardBalanceToggleQuery>(graphql`
    query ProductGiftcardBalanceToggle {
      giftcard: sanityPageGiftcard {
        additionalGiftcardExisting
        additionalGiftcardCheck
      }
    }
  `)

  return (
    <VStack alignItems="center" justifyContent="center" spacing={2} textAlign="center" py={{ base: 2, sm: 6 }}>
      <Text letterSpacing="generous" size="sm" color="grey.coal">
        {giftcard?.additionalGiftcardExisting}
      </Text>
      <FormButton
        color="grey.coal"
        onClick={handleToggle}
        size="underline"
        title={giftcard?.additionalGiftcardCheck}
        aria-label={giftcard?.additionalGiftcardCheck}
        variant="underline"
        borderBottomColor="grey.coal"
      >
        {giftcard?.additionalGiftcardCheck}
      </FormButton>
    </VStack>
  )
})
